import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<IVisaPrepForm, 'hasOtherUkVisas' | 'otherUkVisas'>;

type Params = Fields;

export function getPageStatus({ hasOtherUkVisas, otherUkVisas }: Params): { complete: boolean } {
  let complete = false;
  if (hasOtherUkVisas !== undefined) {
    if (hasOtherUkVisas === false) {
      complete = true;
    } else {
      if (!otherUkVisas || otherUkVisas.length === 0) {
        complete = false;
      } else {
        complete = !otherUkVisas.some(visa => {
          return (
            visa.visaType === '' ||
            visa.issueDate === '' ||
            visa.expiryDate === '' ||
            visa.country === '' ||
            visa.issuingAuthority === ''
          );
        });
      }
    }
  }

  return { complete };
}
